import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AzureMapAddressSearchResult, AzureMapAddressSearchReverseResult } from './azure-map.model';

@Injectable({
  providedIn: 'root',
})
export class AzureMapService {
  private httpClient = inject(HttpClient);
  
  private addressServiceUrl = `https://atlas.microsoft.com/search/address/json?&subscription-key=${environment.azureMapsSubscriptionKey}&api-version=1.0&language=en-US`;
  private reverseGeocodeUrl = `https://atlas.microsoft.com/search/address/reverse/json?api-version=1.0&subscription-key=${environment.azureMapsSubscriptionKey}`;

  getAddressSuggestions(query: string): Observable<AzureMapAddressSearchResult[]> {
    return this.httpClient.get<any>(`${this.addressServiceUrl}&query=${query}`).pipe(map(x => x.results));
  }

  getAddressFromCoordinates(latitude: number, longitude: number): Observable<AzureMapAddressSearchReverseResult> {
    return this.httpClient.get<any>(`${this.reverseGeocodeUrl}&query=${latitude},${longitude}`);
  }

  createPinElement(index: number, selected: boolean, multiple: boolean): string {
    return `<div class="azure-map-custom-pin${selected ? ' selected' : ''}"><div class="azure-map-custom-pin-label">${multiple ? (index + 1).toString() : ''}</div></div>`;
  }
}
